export const knownRoutes = [
  "/",
  "/about-us",
  "/services",
  "/services/neurofeedback",
  "/services/brain-zen-pro",
  "/services/brain-memory-care",
  "/services/allergy-testing",
  "/services/medical-billing-services",
  "/services/osteoarthritis-injections",
  "/services/advance-wound-care",
  "/services/tm-flow-testing-dysfunction",
  "/services/in-house-lab-services",
  "/services/toxicology-laboratory-solutions",
  "/services/marketing-services",
  "/services/transcranial-magnetic-stimulation",
  "/services/emr-subscription",
  // "/blog",
  "/contact-us",
  "/frequently-asked-questions",
  "/terms-and-conditions",
];
